import { DatePicker } from '@/components/ui/datePicker';
import { PreVisitQuestionLabel } from './PreVisitQuestionLabel';
import type { PreVisitQuestionRendererProps } from './preVisitQuestionRendererProps';

export function DateRenderer({ question, value, isInvalid, onChange }: PreVisitQuestionRendererProps) {
  const resolvedValue = typeof value === 'string' ? value : '';
  const inputId = 'pre-visit-question-' + question.code;

  return (
    <div className="space-y-1.5">
      <PreVisitQuestionLabel question={question} htmlFor={inputId} />
      <DatePicker
        id={inputId}
        value={resolvedValue}
        hasError={isInvalid}
        onChange={function change(nextValue) {
          onChange(nextValue);
        }}
      />
    </div>
  );
}
